"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateQuoteComparisonReportDto = exports.UpdateQuoteComparisonReportDocumentDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const create_quote_comparison_report_dto_1 = require("./create-quote-comparison-report.dto");
class UpdateQuoteComparisonReportDocumentDto {
}
exports.UpdateQuoteComparisonReportDocumentDto = UpdateQuoteComparisonReportDocumentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Id",
        example: 237,
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], UpdateQuoteComparisonReportDocumentDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document Type ID",
        example: 237,
    }),
    (0, class_validator_1.IsInt)({ message: "Document Type ID must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document Type ID is required." }),
    tslib_1.__metadata("design:type", Number)
], UpdateQuoteComparisonReportDocumentDto.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document ID",
        example: 25,
    }),
    (0, class_validator_1.IsInt)({ message: "Document ID must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document ID is required." }),
    tslib_1.__metadata("design:type", Number)
], UpdateQuoteComparisonReportDocumentDto.prototype, "documentId", void 0);
class UpdateQuoteComparisonReportDto {
}
exports.UpdateQuoteComparisonReportDto = UpdateQuoteComparisonReportDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 789,
        description: "Opportunity Activity ID",
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], UpdateQuoteComparisonReportDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 403,
        description: "Status LID",
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], UpdateQuoteComparisonReportDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: create_quote_comparison_report_dto_1.PlacementDynamicsSectionDto,
        required: true,
        description: "Placement Dynamics Section",
    }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_quote_comparison_report_dto_1.PlacementDynamicsSectionDto),
    tslib_1.__metadata("design:type", typeof (_a = typeof create_quote_comparison_report_dto_1.PlacementDynamicsSectionDto !== "undefined" && create_quote_comparison_report_dto_1.PlacementDynamicsSectionDto) === "function" ? _a : Object)
], UpdateQuoteComparisonReportDto.prototype, "placementDynamicsSetion", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: [UpdateQuoteComparisonReportDocumentDto],
        description: "Array of documents",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => UpdateQuoteComparisonReportDocumentDto),
    tslib_1.__metadata("design:type", Array)
], UpdateQuoteComparisonReportDto.prototype, "documents", void 0);
